import React, { Component } from 'react'
import LoanListUI from './LoanListUI'
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class LoanListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredLoanList: [],
      copyToClipboardText: null,
      searchFilter: '',
      downloadSubmitted: null,
    }
  }

  render() {
    console.log(this.props.fundSourceList)
    return (
      <LoanListUI
        context={this.props.context}
        loanList={this.state.filteredLoanList}
        fundSourceList={this.props.fundSourceList}
        response={this.props.response}
        openOrClosed={this.props.openOrClosed}
        onRowClick={this.onRowClick}
        onRefreshClick={this.props.onRefreshClick}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    let filtersStr = sessionStorage.getItem(CacheKeys.LoansFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(this.props.loanList, filters.searchFilter ? filters.searchFilter : '')
    // this.getLoanList(context)
  }

  onRowClick = (event) => {
    let loanId = event.currentTarget.getAttribute('data-row-id')
    window.location.href = `/su/loans/${loanId}`
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.props.loanList, searchFilter)
  }

  onDownloadClick = () => {
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true
    })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/loanTape/excel/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  applyFilters(loanList, searchFilter, errorList) {
    let filteredList = loanList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(loan =>
        loan.accountName.toLocaleLowerCase().includes(searchFilter) ||
        (loan.businessName && loan.businessName.toLocaleLowerCase().includes(searchFilter)) ||
        loan.status.includes(searchFilter) ||
        loan.subStatus && loan.subStatus.includes(searchFilter) ||
        loan.assignedUserName && loan.assignedUserName.toLocaleLowerCase().includes(searchFilter)
      )
    }

    this.setState({
      filteredLoanList: filteredList,
      searchFilter: searchFilter,
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.LoansFilter(), JSON.stringify(filters))
  }
}

export default LoanListSF
